import $ from 'jquery';
import { throttle } from 'lodash-es';

const MainMenu = {

	/**
	 * Main menu element.
	 *
	 * @type {object}
	 */
	$el: {},

	/**
	 * Main menu toggle.
	 *
	 * @type {object}
	 */
	$toggle: {},

	/**
	 * Main menu wrapper.
	 *
	 * @type {object}
	 */
	$wrap: {},

	/**
	 * Throttle rate.
	 *
	 * @type {number}
	 */
	throttleTime: 100,

	/**
	 * Initialize.
	 *
	 * @returns {void}
	 */
	init() {

		// Define elements.
		this.$window = $( window );
		this.$header = $( '.c-nav' );
		this.$el     = $( '.c-nav__main' );
		this.$wrap   = this.$el.parent();
		this.$toggle = $( `[data-toggle="#${ this.$el.attr( 'id' ) }"]` );

		// Return if no nav exists
		if ( 0 === this.$el.length ) {
			return;
		}

		// Listen for expander events.
		this.$el
			.on( 'collapse', '.c-nav__expander', this.collapseSub )
			.on( 'expand', '.c-nav__expander', this.expandSub )
			.on( 'click', '.c-nav__expander', this.toggleSub );

		// Listen for main menu toggle events.
		this.$toggle.on( 'click', e => {
			const duration = 300;
			e.preventDefault();
			this.$wrap.removeClass('is-init');

			if ( this.$wrap.hasClass( 'is-expanded' ) ) {
				this.$wrap.removeClass( 'is-expanded' ).slideUp( duration );
			} else {
				this.$wrap.addClass( 'is-expanded' ).slideDown( duration );
			}
		});

		// Listen for resize events.
		this.$window
			.on( 'resize', throttle( () => this.setMenuHeight(), this.throttleTime ) )
			.on( 'orientationchange', this.setMenuHeight() );

		// Set initial max menu height.
		this.$wrap.removeClass('is-init');
		this.setMenuHeight();
		this.$wrap.addClass('is-init');
	},

	/**
	 * Toggle the sub menu.
	 *
	 * @param {Event} e Event
	 * @returns {void}
	 */
	toggleSub( e ) {
		const $expander = $( e.target );

		if ( 'true' === $expander.attr( 'aria-expanded' ) ) {
			$expander.trigger( 'collapse' );
		} else {
			$expander.trigger( 'expand' );
		}
	},

	/**
	 * Collapse the sub menu.
	 *
	 * @param {Event} e Event
	 * @returns {void}
	 */
	collapseSub( e ) {
		const $expander = $( e.target ),
			$menuItem = $expander.parent();

		$expander.attr( 'aria-expanded', false );
		$menuItem.css( 'height', '' );
	},

	/**
	 * Expand the sub menu.
	 *
	 * @param {Event} e Event
	 * @returns {void}
	 */
	expandSub( e ) {
		const $expander = $( e.target ),
			$menuItem = $expander.parent(),
			$subMenu = $expander.siblings( '.c-nav__sub' );

		$expander.attr( 'aria-expanded', true );
		$menuItem.height( $menuItem.height() + $subMenu.height() );
	},

	/**
	 * Set maximum menu height based on available space (let menu scroll when it overflows viewport height).
	 *
	 * @param {Event} e Event
	 * @returns {void}
	 */
	setMenuHeight( e ) {
		if ( ! this.$window || ! this.$header || ! this.$wrap || ! this.$el ) {
			return;
		}

		let height = this.$window.height();
		let header = this.$header.height();
		let menu   = this.$el.height();
		let max    = height - ( header - menu );
		this.$wrap.css({ 'max-height': max });
	}
};

export default MainMenu;
